module.exports = __webpack_public_path__ + "static/media/check-icon.ac2438e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/atoms/Checkbox/check-icon.svg
// module id = 595
// module chunks = 0